import { Action } from '@ngrx/store';
import { Record } from '../models/records.model';

export enum RecordsActionTypes {
  RECORDS_QUERY = '[Records] Query',
  RECORDS_LOADED = '[Records] Fetched',

  RECORDS_ADDED = '[Records] Added',
  RECORDS_EDITED = '[Records] Edited',
  RECORDS_DELETED = '[Records] Deleted',
  RECORDS_SAVED = '[Records] Saved',

  RECORDS_ERROR = '[Records] Error'
}

export class RecordsQuery implements Action {
  readonly type = RecordsActionTypes.RECORDS_QUERY;
}

export class RecordsLoaded implements Action {
  readonly type = RecordsActionTypes.RECORDS_LOADED;

  constructor(public payload: { records: Record[] }) {}
}

export class RecordsAdded implements Action {
  readonly type = RecordsActionTypes.RECORDS_ADDED;

  constructor(public payload: { record: Record }) {}
}

export class RecordsEdited implements Action {
  readonly type = RecordsActionTypes.RECORDS_EDITED;

  constructor(public payload: { record: Record }) {}
}

export class RecordsSaved implements Action {
  readonly type = RecordsActionTypes.RECORDS_SAVED;

  constructor(public payload: {record: Record}) {}
}

export class RecordsDeleted implements Action {
  readonly type = RecordsActionTypes.RECORDS_DELETED;

  constructor(public payload: { record: Record }) {}
}

export class RecordsError implements Action {
  readonly type = RecordsActionTypes.RECORDS_ERROR;

  constructor(public payload: { error: any }) {}
}

export type RecordsActions =
  | RecordsQuery
  | RecordsLoaded
  | RecordsAdded
  | RecordsEdited
  | RecordsSaved
  | RecordsDeleted
  | RecordsError;
